import React from "react";
import { Stack, Text } from "@commonsku/design-system";
import { toTitleCase } from "../../../../utils";
import {
  WorkflowConditionCatalogEntry,
  WorkflowStatusInEntry,
} from "../../catalog/conditions";
import StatusSelectionGrid from "../selection-grid/StatusSelectionGrid";
import { ConditionEditorProps } from "./types";

const isStatusInOption = (
  option: WorkflowConditionCatalogEntry,
): option is WorkflowStatusInEntry =>
  option.type === "status_id" && option.operator === "in";

const getSelectedValues = (value: ConditionEditorProps["condition"]["value"]) =>
  Array.isArray(value) ? value : [];

/**
 * Condition editor for status_id in [...]
 */
export const StatusInConditionEditor = ({
  modelType,
  condition,
  option,
  onChange,
}: ConditionEditorProps) => {
  if (!isStatusInOption(option)) {
    return null;
  }

  const selectedValues = getSelectedValues(condition.value);
  const modelLabel = toTitleCase(modelType);
  const statusTerm = option.status_term === "stage" ? "stages" : "statuses";

  const handleToggle = (value: string) => {
    const isSelected = selectedValues.includes(value);

    if (isSelected && selectedValues.length === 1) {
      return;
    }

    const nextValues = isSelected
      ? selectedValues.filter((selectedValue) => selectedValue !== value)
      : [...new Set([...selectedValues, value])];

    onChange({
      ...condition,
      value: nextValues,
    });
  };

  return (
    <Stack gap="4">
      <Text fontSize="md" fontWeight="medium" lineHeight="unset" margin="0!">
        and the {modelLabel} is in one of these {statusTerm}
      </Text>
      <StatusSelectionGrid
        onToggle={handleToggle}
        options={option.options}
        selectedValues={selectedValues}
      />
    </Stack>
  );
};

export default StatusInConditionEditor;
